import util from 'Utils/commonUtil';
import {get, post, callApi, uploadFile} from 'Utils/apiUtil';
import {
    ltoPurchaseOrderHistoryUrl,
    ltoPurchaseOrderHistoryDetailsUrl,
    proxyOrderAddUrl,
    uploadFileUrl,
    getNotificationChannelUrl,
    reminderNotificationUrl,
    ltoCancelOrderUrl,
} from 'Utils/urlUtil';

export const MYORDERLIST = 'MYORDERLIST';
export const ORDER_SEARCH_IS_LAST_PAGE = 'ORDER_SEARCH_IS_LAST_PAGE';
export const GET_LTO_PURCHASE_ORDER_HISTORY_LIST =
    'GET_LTO_PURCHASE_ORDER_HISTORY_LIST';
export const PURCHASE_ORDER_HISTORY_TAB_ACTIVE =
    'PURCHASE_ORDER_HISTORY_TAB_ACTIVE';
export const UPDATE_LTO_PURCHASE_ORDER_HISTORY_LIST =
    'UPDATE_LTO_PURCHASE_ORDER_HISTORY_LIST';
export const LTO_PURCHASE_ORDER_HISTORY_DETAILS =
    'LTO_PURCHASE_ORDER_HISTORY_DETAILS';
export const ADD_PROXY_ORDER = 'ADD_PROXY_ORDER';

export const GET_NOTIFICATION_CHANNEL = 'GET_NOTIFICATION_CHANNEL';
export const REMINDER_NOTIFICATION = 'REMINDER_NOTIFICATION';
export const CANCEL_LTO_ORDER = 'CANCEL_LTO_ORDER';
export const CLEAR_LTO_LIST_DATA = 'CLEAR_LTO_LIST_DATA';

export const getLtoPurchaseOrderHistoryList = (data) => (dispatch) =>
    dispatch(post(ltoPurchaseOrderHistoryUrl, data)).then((res) => {
        dispatch({type: GET_LTO_PURCHASE_ORDER_HISTORY_LIST, payload: res});
        return res;
    });

// Update Lto purchase order history Tab Active
export const updateLtoPurchaseOrderHistoryTabActive = (params) => ({
    type: PURCHASE_ORDER_HISTORY_TAB_ACTIVE,
    payload: params,
});

export const updateLtoPurchaseOrderHistoryList = (params) => ({
    type: UPDATE_LTO_PURCHASE_ORDER_HISTORY_LIST,
    payload: params,
});

export const getLtoPurchaseOrderHistoryDetails = (id) => {
    console.log('================id', id);
    let purchaseOrderHistoryDetailsUrl =
        ltoPurchaseOrderHistoryDetailsUrl + '/' + id;
    return (dispatch) =>
        dispatch(get(purchaseOrderHistoryDetailsUrl)).then((res) =>
            dispatch({type: LTO_PURCHASE_ORDER_HISTORY_DETAILS, payload: res}),
        );
};

export const addProxyOrder = (params, func) => {
    const request = null;

    const options = {
        data: params,
    };

    const success = [
        (response) => ({type: ADD_PROXY_ORDER, payload: response}),
    ];
    const failure = null;

    return callApi(proxyOrderAddUrl, options, request, success, failure, func);
};

// Upload offine file
export const uploadOffineFile = (data) => uploadFile(uploadFileUrl, data);

export const getNotificationChannel = (data) => (dispatch) =>
    dispatch(post(getNotificationChannelUrl, data)).then((res) => {
        dispatch({type: GET_NOTIFICATION_CHANNEL, payload: res});
        return res;
    });

export const reminderNotification = (data) => (dispatch) =>
    dispatch(post(reminderNotificationUrl, data)).then((res) => {
        dispatch({type: REMINDER_NOTIFICATION, payload: res});
        return res;
    });

export const cancelOrder = (data, callback) => (dispatch) =>
    dispatch(post(ltoCancelOrderUrl, data)).then((res) => {
        if (util.isFunction(callback)) callback(res);
        // dispatch({type: CANCEL_LTO_ORDER, payload: res});
    });

// Update F1 Order Tab Active
export const clearLtoListData = (params) => ({
    type: CLEAR_LTO_LIST_DATA,
    payload: params,
});
